import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full min-h-screen overflow-y-auto bg-play-gray overflow-x-clip" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center h-[70vh] space-x-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 text-3xl font-medium" }, "Creating your account...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";

import api from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupRedirect',
  setup(__props) {

const id_token = ref("");
const state = ref("");

function getQueryStrings() {
  let uri = window.location.href.split("#");
  if (uri.length == 2) {
    let vars = uri[1].split("&");
    let getVars = {};
    let tmp = "";
    vars.forEach(function (v) {
      tmp = v.split("=");
      if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
    });

    id_token.value = getVars["id_token"];
    state.value = getVars["state"];
  }
}

onMounted(async () => {
  try {
    getQueryStrings();

    if (!id_token.value) {
      return alert("Error signing up");
    }

    const res = await api.auth.getSignup(id_token.value, decodeURIComponent(state.value));
    window.location.href = res.data.url;
  } catch (error) {
    console.log(error);
    alert("Error signing up");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})